<template>
  <section>
    <b-row class="content-header">
      <b-col
        class="content-header-left mb-2"
        cols="12"
        md="12"
      >
        <b-row class="breadcrumbs-top">
          <b-col cols="12">
            <h2 class="content-header-title float-left pr-1 mb-0">
              Measurables
            </h2>
            <div class="breadcrumb-wrapper">
              <b-breadcrumb>
                <b-breadcrumb-item to="/">
                  <feather-icon
                    icon="HomeIcon"
                    size="16"
                    class="align-text-top"
                  />
                </b-breadcrumb-item>
                <b-breadcrumb-item to="/measurables-manage">
                  Manage
                </b-breadcrumb-item>
                <b-breadcrumb-item active>
                  {{ action === 'store' ? 'Create Web New Site' : 'Edit Web Site' }}
                </b-breadcrumb-item>
              </b-breadcrumb>
            </div>
          </b-col>
        </b-row>
        <b-row class="match-height">
          <b-col md="12">
            <b-card
              no-body
              class="card-company-table"
            >
              <b-card-body>
                <b-row>
                  <b-col md="6">
                    <b-form-group
                      label="Name"
                      label-for="site-name"
                    >
                      <b-form-input
                        id="site-name"
                        v-model="website.siteName"
                        placeholder="Web Site Name"
                        :state="!$v.website.siteName.$invalid"
                      />
                    </b-form-group>
                  </b-col>
                </b-row>
                <b-row>
                  <b-col md="6">
                    <label for="site-urls">URLs</label>
                    <b-form-textarea
                      v-model="website.urls"
                      id="site-urls"
                      placeholder="http://example.com"
                      rows="3"
                      :state="!$v.website.urls.$invalid"
                    />
                  </b-col>
                  <b-col md="6">
                    <b-alert variant="primary" show>
                      <div class="alert-body">
                        <span>It is recommended, but not required, to specify the various URLs, one per line, that your visitors use to access this website. Note that it is not necessary to specify the URLs with and without 'www' as Matomo automatically considers both.</span>
                      </div>
                    </b-alert>
                  </b-col>
                </b-row>
<!--                <b-row class="pt-1">-->
<!--                  <b-col md="6">-->
<!--                    <b-form-checkbox v-model="website.excludeUnknownUrls">-->
<!--                      Only track visits and actions when the action URL starts with one of the above URLs.-->
<!--                    </b-form-checkbox>-->
<!--                  </b-col>-->
<!--                  <b-col md="6">-->
<!--                    <b-alert variant="primary" show>-->
<!--                      <div class="alert-body">-->
<!--                        <span>When enabled, Matomo will only track internal actions when the Page URL is one of the known URLs for your website. This prevents people from spamming your analytics with URLs for other websites.<br/>-->
<!--The domain and the path have to be an exact match and each valid subdomain has to be specified separately. For example when the known URLs are 'http://example.com/path' and 'http://good.example.com', tracking requests for 'http://example.com/otherpath' or 'http://bad.example.com' are ignored.</span>-->
<!--                      </div>-->
<!--                    </b-alert>-->
<!--                  </b-col>-->
<!--                </b-row>-->
<!--                <b-row>-->
<!--                  <b-col md="6">-->
<!--                    <b-form-checkbox v-model="website.keepURLFragments">-->
<!--                      Keep Page URL fragments when tracking Page URLs-->
<!--                    </b-form-checkbox>-->
<!--                  </b-col>-->
<!--                  <b-col md="6">-->
<!--                    <b-alert variant="primary" show>-->
<!--                      <div class="alert-body">-->
<!--                        <span>Default: Yes (Default)</span>-->
<!--                      </div>-->
<!--                    </b-alert>-->
<!--                  </b-col>-->
<!--                </b-row>-->
<!--                <b-row>-->
<!--                  <b-col md="6">-->
<!--                    <label for="site-textarea">Excluded IPs</label>-->
<!--                    <b-form-textarea-->
<!--                      v-model="website.excludedIps"-->
<!--                      id="site-textarea"-->
<!--                      placeholder="127.0.0.1"-->
<!--                      rows="3"-->
<!--                    />-->
<!--                  </b-col>-->
<!--                  <b-col md="6">-->
<!--                    <b-alert variant="primary" show>-->
<!--                      <div class="alert-body">-->
<!--                        <span>Enter the list of IPs, one per line, that you wish to exclude from being tracked by Matomo. You can use CIDR notation eg. 1.2.3.4/24 or you can use wildcards, eg. 1.2.3.* or 1.2.*.*<br/><br/>-->
<!--Your current IP address is 127.0.0.1</span>-->
<!--                      </div>-->
<!--                    </b-alert>-->
<!--                  </b-col>-->
<!--                </b-row>-->
<!--                <b-row>-->
<!--                  <b-col md="6">-->
<!--                    <label for="site-excludedQuery">Excluded Parameters</label>-->
<!--                    <b-form-textarea-->
<!--                      v-model="website.excludedQueryParameters"-->
<!--                      id="site-excludedQuery"-->
<!--                      rows="3"-->
<!--                    />-->
<!--                  </b-col>-->
<!--                  <b-col md="6">-->
<!--                    <b-alert variant="primary" show>-->
<!--                      <div class="alert-body">-->
<!--                        <span>Enter the list of URL Query Parameters, one per line, to exclude from the Page URLs reports. Regular expressions such as /^sess.*|.*[dD]ate$/ are supported.<br/><br/>-->
<!--Matomo will automatically exclude the common session parameters (phpsessid, sessionid, ...).</span>-->
<!--                      </div>-->
<!--                    </b-alert>-->
<!--                  </b-col>-->
<!--                </b-row>-->
<!--                <b-row>-->
<!--                  <b-col md="6">-->
<!--                    <label for="site-excludedUserAgents">Excluded User Agents</label>-->
<!--                    <b-form-textarea-->
<!--                      v-model="website.excludedUserAgents"-->
<!--                      id="site-excludedUserAgents"-->
<!--                      rows="3"-->
<!--                    />-->
<!--                  </b-col>-->
<!--                  <b-col md="6">-->
<!--                    <b-alert variant="primary" show>-->
<!--                      <div class="alert-body">-->
<!--                        <span>Enter the list of user agents to exclude from being tracked by Matomo.<br/><br/>-->
<!--If the visitor's user agent string contains any of the strings you specify, the visitor will be excluded from Matomo.<br/>-->
<!--You can use this to exclude some bots from being tracked. Regular expressions such as /bot|spider|crawl|scanner/i are supported.</span>-->
<!--                      </div>-->
<!--                    </b-alert>-->
<!--                  </b-col>-->
<!--                </b-row>-->
<!--                <b-row>-->
<!--                  <b-col md="6">-->
<!--                    <b-form-checkbox v-model="website.siteSearch">-->
<!--                      Track Site Search-->
<!--                    </b-form-checkbox>-->
<!--                  </b-col>-->
<!--                  <b-col md="6">-->
<!--                    <b-alert variant="primary" show>-->
<!--                      <div class="alert-body">-->
<!--                  <span>You can use Matomo to track and report what visitors are searching in your website's internal search engine.<br/>-->
<!--Default: Site Search tracking enabled</span>-->
<!--                      </div>-->
<!--                    </b-alert>-->
<!--                  </b-col>-->
<!--                </b-row>-->
<!--                <b-row v-if="website.siteSearch">-->
<!--                  <b-col md="6">-->
<!--                    <b-form-checkbox v-model="website.useDefaultSiteSearchParams">-->
<!--                      Use default Site Search parameters-->
<!--                    </b-form-checkbox>-->
<!--                  </b-col>-->
<!--                  <b-col md="6">-->
<!--                    <b-alert variant="primary" show>-->
<!--                      <div class="alert-body">-->
<!--                  <span>Query parameter (Default): q,query,s,search,searchword,k,keyword & Category parameter</span>-->
<!--                      </div>-->
<!--                    </b-alert>-->
<!--                  </b-col>-->
<!--                </b-row>-->
<!--                <b-row v-if="website.siteSearch && !website.useDefaultSiteSearchParams">-->
<!--                  <b-col md="6">-->
<!--                    <b-form-group-->
<!--                      label="Query parameter"-->
<!--                      label-for="site-searchKeywordParameters"-->
<!--                    >-->
<!--                      <b-form-input-->
<!--                        id="site-searchKeywordParameters"-->
<!--                        v-model="website.searchKeywordParameters"-->
<!--                      />-->
<!--                    </b-form-group>-->
<!--                  </b-col>-->
<!--                  <b-col md="6">-->
<!--                    <b-alert variant="primary" show>-->
<!--                      <div class="alert-body">-->
<!--                        <span>Enter a comma separated list of all query parameter names containing the site search keyword.</span>-->
<!--                      </div>-->
<!--                    </b-alert>-->
<!--                  </b-col>-->
<!--                </b-row>-->
<!--                <b-row v-if="website.siteSearch && !website.useDefaultSiteSearchParams">-->
<!--                  <b-col md="6">-->
<!--                    <b-form-group-->
<!--                      label="Category parameter"-->
<!--                      label-for="site-searchCategoryParameters"-->
<!--                    >-->
<!--                      <b-form-input-->
<!--                        id="site-searchCategoryParameters"-->
<!--                        v-model="website.searchCategoryParameters"-->
<!--                      />-->
<!--                    </b-form-group>-->
<!--                  </b-col>-->
<!--                  <b-col md="6">-->
<!--                    <b-alert variant="primary" show>-->
<!--                      <div class="alert-body">-->
<!--                        <span>(optional)<br /><br />You may enter a comma-separated list of query parameters specifying the search category.</span>-->
<!--                      </div>-->
<!--                    </b-alert>-->
<!--                  </b-col>-->
<!--                </b-row>-->
<!--                <b-row>-->
<!--                  <b-col md="6">-->
<!--                    <b-form-checkbox v-model="website.ecommerce">-->
<!--                      Ecommerce Web Site-->
<!--                    </b-form-checkbox>-->
<!--                  </b-col>-->
<!--                  <b-col md="6">-->
<!--                    <b-alert variant="primary" show>-->
<!--                      <div class="alert-body">-->
<!--                  <span>When enabled, the "Goals" report will have a new "Ecommerce" section.-->
<!--Matomo allows for advanced Ecommerce Analytics tracking & reporting.<br/>-->
<!--Default: Not an Ecommerce site</span>-->
<!--                      </div>-->
<!--                    </b-alert>-->
<!--                  </b-col>-->
<!--                </b-row>-->
<!--                <b-row>-->
<!--                  <b-col md="6">-->
<!--                    <b-form-group>-->
<!--                      <v-select-->
<!--                        v-model="website.currency"-->
<!--                        :options="currencyList"-->
<!--                        :clearable="false"-->
<!--                        :reduce="c => c.value"-->
<!--                        placeholder="Currency"-->
<!--                        :state="!$v.website.currency.$invalid"-->
<!--                      />-->
<!--                    </b-form-group>-->
<!--                  </b-col>-->
<!--                  <b-col md="6">-->
<!--                    <b-alert variant="primary" show>-->
<!--                      <div class="alert-body">-->
<!--                  <span>The Currency symbol will be displayed next to Goals revenues.</span>-->
<!--                      </div>-->
<!--                    </b-alert>-->
<!--                  </b-col>-->
<!--                </b-row>-->
<!--                <b-row>-->
<!--                  <b-col md="6">-->
<!--                    <b-form-group>-->
<!--                      <v-select-->
<!--                        v-model="website.timezone"-->
<!--                        :options="timezonesList"-->
<!--                        :clearable="false"-->
<!--                        :reduce="tz => tz.value"-->
<!--                        placeholder="Time zone"-->
<!--                        :state="!$v.website.timezone.$invalid"-->
<!--                      />-->
<!--                    </b-form-group>-->
<!--                  </b-col>-->
<!--                  <b-col md="6">-->
<!--                    <b-alert variant="primary" show>-->
<!--                      <div class="alert-body">-->
<!--                        <span>Changing your time zone will only affect data going forward, and will not be applied retroactively.</span>-->
<!--                      </div>-->
<!--                    </b-alert>-->
<!--                  </b-col>-->
<!--                </b-row>-->
                <b-row>
                  <b-col md="6">
                    <b-button
                      v-ripple.400="'rgba(255, 255, 255, 0.15)'"
                      variant="primary"
                      class="mr-1 mt-1"
                      @click="save"
                      :disabled="$v.website.$invalid"
                    >
                      Save changes
                    </b-button>
                    <b-button
                      v-ripple.400="'rgba(186, 191, 199, 0.15)'"
                      type="reset"
                      class="mt-1"
                      variant="outline-secondary"
                    >
                      Cancel
                    </b-button>
                  </b-col>
                </b-row>
              </b-card-body>
            </b-card>
          </b-col>

        </b-row>
      </b-col>
    </b-row>
  </section>
</template>

<script>
import { required } from 'vuelidate/lib/validators'
import api from '@/libs/axios'
import { hmError, hmSuccess } from '@/libs/toastification'
import hmStorage from '@core/utils/hm_storage'

export default {
  data() {
    return {
      currencyList: [],
      timezonesList: [],
      action: null,
      website: {
        idSite: null,
        siteName: null,
        urls: '',
        excludedQueryParameters: null,
        excludedUserAgents: null,
        siteSearch: false,
        useDefaultSiteSearchParams: true,
        searchKeywordParameters: null,
        searchCategoryParameters: null,
        ecommerce: false,
        keepURLFragments: true,
        excludedIps: null,
        currency: null,
        timezone: null,
        excludeUnknownUrls: false
      },
      globalSettings: {
        defaultCurrency: null,
        defaultTimezone: null
      }
    }
  },
  validations: {
    website: {
      siteName: { required },
      urls: { required },
      timezone: { required },
      currency: { required }
    }
  },
  methods: {
    async get_lookups() {
      return api.post('/api/matomo/site/get_data').then(r => {
        if (r.data.code !== 'Ok') return hmError('Error reading lookups')
        Object.assign(this.globalSettings, r.data.globalSettings)
        this.currencyList = Object.getOwnPropertyNames(r.data.currencyList).map(p => {
          return {label: r.data.currencyList[p], value: p}
        })
        this.timezonesList = Object.getOwnPropertyNames(r.data.timezonesList).reduce((carry, p) => {
          carry.push(...Object.getOwnPropertyNames(r.data.timezonesList[p]).map(t => {
            return {label: `[${p}] ${r.data.timezonesList[p][t]}`, value: t}
          }))
          return carry
        }, [])
      }).catch(e => {
        console.error(e)
        hmError('Error reading lookups')
      })
    },
    initAction(cmd) {
      this.action = cmd
      if (cmd === 'store') {
        this.website.timezone = this.globalSettings.defaultTimezone
        this.website.currency = this.globalSettings.defaultCurrency
      } else {
        if (!hmStorage.hasLocal('website')) {
          return this.$router.push('/all-web-sites')
        }
        const sw = hmStorage.getLocalItem('website')
        this.website.idSite = sw.idsite
        this.website.siteName = sw.name
        this.website.urls = sw.alias_urls.join('\n')
        this.website.ecommerce = (Boolean)(parseInt(sw.ecommerce))
        this.website.siteSearch = (Boolean)(parseInt(sw.sitesearch))
        this.website.timezone = sw.timezone
        this.website.currency = sw.currency
        this.website.excludedIps = sw.excluded_ips.split(',').join('\n')
        this.website.excludedQueryParameters = sw.excluded_parameters.split(',').join('\n')
        this.website.excludedUserAgents = sw.excluded_user_agents.split(',').join('\n')
        this.website.searchCategoryParameters = sw.sitesearch_category_parameters
        this.website.searchKeywordParameters = sw.sitesearch_keyword_parameters
        this.website.useDefaultSiteSearchParams = !sw.sitesearch_keyword_parameters
        this.website.excludeUnknownUrls = (Boolean)(parseInt(sw.exclude_unknown_urls))
      }
    },
    save() {
      api.post(`/api/matomo/site/${this.action}`, { website: this.website }).then(r => {
        if (r.data.code !== 'Ok') return hmError('Error creating/updating Web Site')
        hmSuccess('Operation was successful')
        this.$router.push('/measurables-manage')
      })
    }
  },
  async mounted() {
    if (!this.$route.params.cmd || ['store', 'update'].indexOf(this.$route.params.cmd) === -1) {
      await this.$router.push('/all-web-sites')
    }
    await this.get_lookups()
    this.initAction(this.$route.params.cmd)
  }
}
</script>
